/*
 * @Author:
 * @LastEditTime: 2022-07-21 16:21:04
 * @Description:
 */
import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class ClipTool {
  // 新增刨切记录
  static async addClip(payload) {
    const [err, res] = await To(
      wizStandardInstance.post(
        '/api/Three_Dimensional_Sectioning/three_dimensional_sectioning',
        payload
      )
    )
    return Callback(err, res)
  }
  // 编辑刨切
  static async editClip(payload) {
    const [err, res] = await To(
      wizStandardInstance.put(
        '/api/Three_Dimensional_Sectioning/three_dimensional_sectioning',
        payload
      )
    )
    return Callback(err, res)
  }
  // 删除刨切
  static async deleteClip(payload) {
    const [err, res] = await To(
      wizStandardInstance.delete('/api/Three_Dimensional_Sectioning/three_dimensional_sectioning', {
        data: payload,
      })
    )
    return Callback(err, res)
  }
  // 剖记录页面查询
  static async getClipList(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/Three_Dimensional_Sectioning/query_list?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }
}
